import * as React from 'react';
import { useTreeItem } from '@mui/lab/TreeItem';
import clsx from 'clsx';
import { Typography } from '@mui/material';

const GenericContent = React.forwardRef(function GenericContent(props, ref) {
	const {
	    classes,
	    className,
	    label,
	    nodeId,
	    expansionIcon,
	    onClick,
	} = props;

	const {
	    handleExpansion,
	} = useTreeItem(nodeId);

	const handleExpansionClick = (event) => {
	    handleExpansion(event);
	};

	return (
	    <div
	      className={clsx(className, classes.root)}
	      ref={ref}
	    >
	      <div onClick={handleExpansionClick} className={classes.iconContainer}>
	        {expansionIcon}
	      </div>
	      <Typography
	        onClick={onClick}
	        component="div"
	        sx={{ fontFamily: '"Roboto", "sans-serif"', fontSize: 18 }}
	      >
	        {label}
	      </Typography>
	    </div>
	);
});

export default GenericContent;
